import MediaMenuItem from './MediaMenuItem'
import { connect } from 'react-redux'
import { State } from '../../../dataStore/reducers/reducerType'
import { MediaMenuItemProps } from './types'

const mapStateToProps = (state: State, props: Omit<MediaMenuItemProps, 'BTID'>): MediaMenuItemProps => ({
  ...props,
  BTID: state.user.BTID
})

export default connect(mapStateToProps)(MediaMenuItem)
